var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseModal = function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42474D",
    fillRule: "evenodd",
    d: "M8.01 5.35a1.88 1.88 0 0 0-2.66 2.66L9.34 12l-3.99 3.99a1.88 1.88 0 0 0 2.66 2.66L12 14.66l3.99 3.99a1.88 1.88 0 0 0 2.659-2.66L14.659 12l3.99-3.99a1.88 1.88 0 0 0-2.66-2.66L12 9.34z",
    clipRule: "evenodd"
  })));
};
export { SvgCloseModal as ReactComponent };